export default __webpack_public_path__ + "static/media/mon_256.3eeb0964.png";